<template>
  <ubi-page-container class="Calendar" wide-main-content>
    <!-- Formulaire de filtres ApiSearchForm -->
    <div v-if="hasAccessCalendar">
      <ApiSearchForm
        :key="$route.fullPath"
        route="calendrier"
        :business-domain="businessDomain"
        :user-context="userContext"
        @search="handleSearchFromApi"
        @reset="handleResetFromApi"
        @month-change="handleMonthChange"
      />
    </div>

    <!-- calendar -->
    <ubi-panel>
      <v-app v-if="hasAccessCalendar" >
        <v-row class="fill-height">
          <v-col cols="12" class="Calendar-col">
            <v-sheet height="64" class="mb-6">
              <ToolbarCalendar
                  :today="today"
                  :getRefCalendar="() => $refs"
                  :type="type"
                  @setType="setType"
                  @setToday="setToday"
                  @prevClicked="prevClicked"
                  @nextClicked="nextClicked"
              />
            </v-sheet>

            <!-- Event dialog Component date time Picker -->
            <v-row justify="center">
              <v-dialog
                  @click:outside="closeDialog"
                  v-model="datetimeDialog"
                  width="290px"
              >
                <datetime-picker @updatedDateTime="updatedDateTime" :eventSelected="selectedEvent" @setType="setType"/>
              </v-dialog>
            </v-row>
            <!-- calendrier : pleine largeur du conteneur élargi, hauteur liée à la fenêtre -->
            <v-sheet class="Calendar-calendarSheet">
              <v-calendar
                  class="calendar-loader"
                  ref="calendar"
                  color="#0AB1BF"
                  v-model="focus"
                  :events="getAllEvents"
                  locale="fr"
                  :event-margin-bottom="3"
                  :type="type"
                  :now="today"
                  @click:event="showEvent"
                  @click:more="viewDay"
                  @click:date="viewDay"
              >
              </v-calendar>
              <div class="wait-calendar-events" v-if="getIsLoading">
                <div class="text-loading-and-loader">
                  <DoubleBounce />
                  <p>{{ $t('general.calendar.loaderMessageCalendar')}}</p>
                </div>
              </div>
              <v-menu
                  v-model="selectedOpen"
                  :close-on-content-click="false"
                  :activator="selectedElement"
                  :key="selectedEvent.id"
                  open-on-focus
              >
                <CardModalCalendar
                    :events="getAllEvents"
                    :selectedEvent="selectedEvent"
                    @scheduledEventCalendar="scheduledEventCalendar"
                    @deleteEventCalendar="deleteEventCalendar"
                    @closeEvent="closeEvent"/>
              </v-menu>
            </v-sheet>
          </v-col>
        </v-row>
      </v-app>
      <div v-else>
        <TeasingCalendar :isSubUser="isSubUser"/>
      </div>
    </ubi-panel>
  </ubi-page-container>
</template>

<script>
import { mapGetters } from 'vuex'
import UbiPanel from '@/components/Panel.vue'
import DatetimePicker from '@/pages/calendar/components/DatetimePicker.vue'
import ToolbarCalendar from '@/pages/calendar/components/ToolbarCalendar.vue'
import CardModalCalendar from '@/pages/calendar/components/CardModalCalendar.vue'
import TeasingCalendar from '@/pages/calendar/components/TeasingCalendar.vue'
import UbiPageContainer from '@/components/PageContainer.vue'
import { $t } from '@/i18n'
import DoubleBounce from '@/components/spinners/DoubleBounce.vue'
import ApiSearchForm from '@/components/search/ApiSearchForm.vue'
import {
  getFirstAndLastDayFromDate,
  getFirstAndLastDayOfMonth,
  getNextMonthDate,
  getPreviousMonthDate,
  getRangeMonth
} from '@/helpers/functions/convertDate'

export default {
  name: 'Calendar',
  components: {
    DoubleBounce,
    UbiPageContainer,
    UbiPanel,
    DatetimePicker,
    ToolbarCalendar,
    CardModalCalendar,
    TeasingCalendar,
    ApiSearchForm
  },
  data () {
    return {
      today: new Date().toISOString().substring(0, 10),
      focus: new Date().toISOString().substring(0, 10),
      type: 'month',
      options: [],
      pickerOptionsDateFin: {
        disabledDate (time) {
          return time.getTime() > Date.now()
        }
      },
      name: null,
      details: null,
      end: null,
      color: '#3b5998',
      currentlyEditing: null,
      selectedEvent: {},
      selectedElement: null,
      selectedOpen: false,
      datetimeDialog: false,
      hasAccess: true,
      editCloseDialog: false,
      monthSelected: ''
    }
  },
  computed: {
    ...mapGetters(['isSubUser']),
    sitimmoUser () {
      return this.$store.state.app.sitimmoUser
    },
    user () {
      return this.$store.state.app.user
    },
    getAllEvents () {
      return this.$store.getters['calendarSocialPosts/getListEvents']
    },
    hasAccessCalendar () {
      // return true
      return this.sitimmoUser.produitCalendrier
    },
    getIsLoading () {
      return this.$store.getters['calendarSocialPosts/getIsLoadingStatus']
    },
    businessDomain () {
      return this.sitimmoUser.univers ? this.sitimmoUser.univers.toLowerCase() : 'immo'
    },
    userContext () {
      return {
        userId: this.sitimmoUser.id,
        univers: this.sitimmoUser.univers,
        metier: this.sitimmoUser.metier
      }
    }
  },
  methods: {
    // === MÉTHODES POUR ApiSearchForm ===
    handleSearchFromApi (filters) {
      console.log('🔍 Calendar - Filtres reçus:', filters)

      // Mapper les filtres reçus vers le store Vuex
      if (filters.search !== undefined) {
        this.$store.commit('calendarSocialPosts/setFilters', { key: 'search', value: filters.search })
      }
      if (filters.typePost !== undefined) {
        this.$store.commit('calendarSocialPosts/setFilters', { key: 'typePost', value: filters.typePost })
      }
      if (filters.network !== undefined) {
        this.$store.commit('calendarSocialPosts/setFilters', { key: 'network', value: filters.network })
      }
      // startDate et endDate sont gérés par handleMonthChange

      // Charger les événements
      this.$store.dispatch('calendarSocialPosts/loadEvents')
    },

    handleResetFromApi () {
      console.log('🔄 Calendar - Reset des filtres')

      // Réinitialiser les filtres dans le store
      this.$store.commit('calendarSocialPosts/resetFilters')

      // Réinitialiser le focus du calendrier à aujourd'hui
      this.focus = this.today
      this.monthSelected = ''

      // Charger les événements
      this.$store.dispatch('calendarSocialPosts/loadEvents')
    },

    handleMonthChange (monthData) {
      console.log('🗓️ Calendar - Month changed:', monthData)

      // Extraire startDate et endDate depuis monthData
      const { monthValue, startDate, endDate } = monthData

      // Mettre à jour les filtres dans le store
      this.$store.commit('calendarSocialPosts/setFilters', { key: 'startDate', value: startDate })
      this.$store.commit('calendarSocialPosts/setFilters', { key: 'endDate', value: endDate })

      // Synchroniser le focus du calendrier Vuetify avec le mois sélectionné
      this.focus = monthValue
      this.monthSelected = monthValue

      // Charger les événements avec les nouvelles dates
      this.$store.dispatch('calendarSocialPosts/loadEvents')
    },

    viewDay ({ date }) {
      this.$router.push({ name: 'calendrier-details', params: { date: date } })
    },
    setToday (args) {
      this.focus = args.today
    },
    setType (args) {
      this.type = args
    },
    closeDialog () {
      this.datetimeDialog = false
    },
    closeEvent (args) {
      this.selectedEvent = args
      this.selectedOpen = false
    },
    deleteEventCalendar (args) {
      const [action, networkEvent] = args
      if (action === 'Delete') {
        this.datetimeDialog = false
        this.$confirm(
          $t('general.calendar.areYouSureYouWantToDeleteYourSchedule'),
          $t('general.calendar.deletionPost'),
          {
            confirmButtonText: $t('general.calendar.acceptedPost'),
            cancelButtonText: $t('general.calendar.refusedPost'),
            type: 'warning'
          }
        ).then(() => {
          try {
            this.selectedOpen = false
            this.$store.dispatch('calendarSocialPosts/deleteScheduled', [networkEvent])
            this.$message({
              type: 'success',
              message: $t('general.calendar.deletionHasBeenCompleted')
            })
          } catch (e) {
            this.$message({
              type: 'error',
              message: $t('general.calendar.deletionFailed')
            })
          }
        })
      }
    },
    showEvent ({ nativeEvent, event }) {
      const open = () => {
        this.selectedEvent = event
        this.selectedElement = nativeEvent.target
        requestAnimationFrame(() => requestAnimationFrame(() => this.selectedOpen = true))
      }

      if (this.selectedOpen) {
        this.selectedOpen = false
        requestAnimationFrame(() => requestAnimationFrame(() => open()))
      } else {
        open()
      }
      nativeEvent.stopPropagation()
    },
    scheduledEventCalendar () {
      this.datetimeDialog = open
    },
    updatedDateTime (args) {
      const [eventSelected, time, date, datetimeDialog] = args
      this.$confirm(
        $t('general.calendar.areYouSureYouWantToChangeYourSchedule'),
        $t('general.calendar.Amendment'),
        {
          confirmButtonText: $t('general.calendar.acceptedPost'),
          cancelButtonText: $t('general.calendar.refusedPost'),
          type: 'warning'
        }
      ).then(() => {
        try {
          if (new Date(date) >= new Date()) {
            this.$store.dispatch('calendarSocialPosts/updateCronExpressionEvent', [eventSelected, time, date])
            this.datetimeDialog = datetimeDialog
            this.date = ''
            this.time = ''
            this.$message({
              type: 'success',
              message: $t('general.calendar.theChangeHasBeenMade')
            })
          } else {
            this.$message({
              type: 'warning',
              message: $t('general.calendar.warningSheduledBefore')
            })
          }
        } catch (e) {
          this.$message({
            type: 'error',
            message: $t('general.calendar.theChangeHasBeenUndone')
          })
        }
      })
    },
    prevClicked ({ date }) {
      const currentDate = new Date(date)
      const debutMoisPrecedent = new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1)
      const finMoisPrecedent = new Date(currentDate.getFullYear(), currentDate.getMonth(), 0)
      const selectedDate = { startDate: this.formatDate(debutMoisPrecedent), endDate: this.formatDate(finMoisPrecedent) }

      // Mettre à jour les filtres
      this.$store.commit('calendarSocialPosts/setFilters', { key: 'startDate', value: selectedDate.startDate })
      this.$store.commit('calendarSocialPosts/setFilters', { key: 'endDate', value: selectedDate.endDate })

      // Synchroniser monthSelected (format YYYY-MM)
      this.monthSelected = this.formatMonthToString(debutMoisPrecedent)

      // Charger les événements
      this.$store.dispatch('calendarSocialPosts/loadEvents')
    },
    nextClicked ({ date }) {
      const currentDate = new Date(date)
      const debutMoisSuivant = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1)
      const finMoisSuivant = new Date(currentDate.getFullYear(), currentDate.getMonth() + 2, 0)
      const selectedDate = { startDate: this.formatDate(debutMoisSuivant), endDate: this.formatDate(finMoisSuivant) }

      // Mettre à jour les filtres
      this.$store.commit('calendarSocialPosts/setFilters', { key: 'startDate', value: selectedDate.startDate })
      this.$store.commit('calendarSocialPosts/setFilters', { key: 'endDate', value: selectedDate.endDate })

      // Synchroniser monthSelected (format YYYY-MM)
      this.monthSelected = this.formatMonthToString(debutMoisSuivant)

      // Charger les événements
      this.$store.dispatch('calendarSocialPosts/loadEvents')
    },
    formatDate (date) {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },
    formatMonthToString (date) {
      if (!date) return null
      if (typeof date === 'string') return date

      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      return `${year}-${month}`
    }
  },
  mounted () {
    // ApiSearchForm gère le chargement initial des événements via son lifecycle
    // Pas besoin de charger manuellement ici
  }
}
</script>
<style lang="scss" scoped>
@import "../../theme/_bootstrap.scss";

.Calendar {
  .Calendar-col {
    max-width: 100%;
  }

  /* Calendrier Vuetify : occupe toute la largeur utile (plus de 960px figés) */
  .Calendar-calendarSheet {
    position: relative;
    width: 100%;
    max-width: 100%;
    /* Plus haut sur grands écrans, borne min/max pour petits écrans */
    height: clamp(520px, 68vh, 920px);
    min-height: clamp(520px, 68vh, 920px);
  }

  .Calendar-calendarSheet ::v-deep .v-calendar {
    width: 100%;
    height: 100%;
  }

  /* Personnalisation du Panel de recherche : garder barre verte, supprimer ombre/bordures */
  ::v-deep .el-card.Panel.is-always-shadow {
    box-shadow: none !important;
    -webkit-box-shadow: none !important;
    border-left: none !important;
    border-right: none !important;
    border-top: none !important;
    border: none !important;
    border-bottom: none !important;
  }

  /* Réduire le padding du Panel de 34px à 5px */
  ::v-deep .el-card.Panel.is-always-shadow .el-card__body {
    padding: 5px !important;
  }
}

/* v-app intégré : laisser la hauteur suivre le contenu (évite une page vide sous le calendrier élargi) */
.Calendar ::v-deep .v-application {
  height: auto !important;
  min-height: 0 !important;
}
.my-event {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  border-radius: 2px;
  background-color: #EBF3F2;
  color: #1A4A56;
  border: 1px solid #EAEDF0;
  width: 100%;
  font-size: 12px;
  padding: 3px;
  cursor: pointer;
  margin-bottom: 1px;
}

.calendar-loader{
  position: relative;
}

.wait-calendar-events{
  width: 100%;
  height: 100%;
  background-color: rgba(15, 55, 65, 0.6);
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  position: absolute;
  top:40%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 800;
  display: flex;
  justify-content: center;
  align-items: center;

  .text-loading-and-loader {
    padding: 10px 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    font-family: "Dosis", sans-serif;
    z-index: 802;
    p {
    font-size: 16px;
    font-weight: 500;
    color: white;
    margin: 30px 0;
  }
  }
}
</style>
